// @greenlight-spec: 28-it-dashboard-ui.md
import type { PipelineFailureListItem } from '@greenlight/contract';

export function changeLabel(item: PipelineFailureListItem): string {
  return item.pull_request_number !== null ? `PR #${item.pull_request_number}` : item.branch;
}

/** The selected failures as one document, oldest first, matching the feedback hand-off layout. */
export function renderPipelineFailuresMarkdown(items: readonly PipelineFailureListItem[]): string {
  const sections = [...items]
    .sort((a, b) => a.triggered_at.localeCompare(b.triggered_at))
    .map((item) => {
      const checks =
        item.failed_checks.length === 0
          ? ['- No failed check recorded']
          : item.failed_checks.map((c) =>
              c.error_summary
                ? `- \`${c.check_name}\`: ${c.error_summary}`
                : `- \`${c.check_name}\``,
            );
      return [
        `## ${item.app_slug} · ${changeLabel(item)}`,
        '',
        `- App: ${item.app_name} (\`${item.app_slug}\`)`,
        `- Branch: \`${item.branch}\``,
        ...(item.pull_request_number !== null
          ? [`- Pull request: #${item.pull_request_number}`]
          : []),
        `- Commit: \`${item.commit_sha}\``,
        `- Triggered: ${item.triggered_at}`,
        ...(item.completed_at ? [`- Completed: ${item.completed_at}`] : []),
        '',
        '### Failed checks',
        '',
        ...checks,
      ].join('\n');
    });
  return `# Greenlight pipeline failures\n\n${sections.join('\n\n---\n\n')}\n`;
}
